import React from "react";

const ChevronUp = props => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    <path
      stroke="currentColor"
      d="M23 16L12 8 1 16"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChevronUp;



// WEBPACK FOOTER //
// ./src/theme/icons/ChevronUp.js